import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

interface LoadingDisplayProps {
  message?: string;
}

const LoadingDisplay: React.FC<LoadingDisplayProps> = (props) => {
  let { message = 'Loading...' } = props;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '25%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3,
        zIndex: 1000,
      }}
    >
      <CircularProgress
        size={56}
        thickness={3.6}
        sx={{
          color: 'primary.main',
        }}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          fontWeight: 500,
          letterSpacing: '0.02em',
          fontSize: '0.95rem',
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingDisplay;
